module.exports = __webpack_public_path__ + "static/media/home.5e8f4fa9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/home.svg
// module id = 1106
// module chunks = 0